// project import
import {
  orgScopeSpecificItem,
  siteScopeSpecificItem,
  pages,
  surveillancePages,
} from "./pages";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [orgScopeSpecificItem, siteScopeSpecificItem, pages, surveillancePages],
};

export default menuItems;
